import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'
import { HAS_TOUCH } from 'constants/environment'

const Arrow = () => (
  <div
    style={{
      position: 'absolute',
      left: '-10.1px',
      top: '7.4px',
      overflow: 'hidden',
      width: '10px',
      height: '55%'
    }}>
    <svg viewBox="0 0 10 21">
      <polygon style={{ fill: '#fff' }} points="10 0.73 1.37 10.5 10 20.27 10 0.73" />
      <polygon
        style={{ fill: '#d5d5d5' }}
        points="9.28 21 0 10.5 9.28 0 9.28 0 10 0 10 0.73 10 0.73 1.37 10.5 10 20.27 10 20.27 10 21 9.28 21 9.28 21" />
    </svg>
  </div>
)

/** Step Counter Component. */
class StepCounter extends Component {
  constructor() {
    super()
    this.state = {
      hover: -1
    }
  }
  static propTypes = {
    steps: PropTypes.array.isRequired,
    horizontal: PropTypes.bool,
    hidden: PropTypes.bool,
    active: PropTypes.number,
    setStep: PropTypes.func
  }
  hover = (index) => {
    this.setState({ hover: index })
  }
  reset = () => {
    this.setState({ hover: -1 })
  }
  render() {
    const {
      horizontal, hidden, steps, active, setStep, theme = 'dark'
    } = this.props
    const { hover } = this.state

    return (
      <ol
        data-test="StepCounter"
        style={[
          styles.base,
          { flexDirection: horizontal ? 'row' : 'column' },
          hidden ? styles.hide : styles.show
        ]}>
        {steps.map((step, index) => (
          <li key={index} style={[styles.step]}>
            <div
              data-test={`step-counter-item-${index}`}
              key={index}
              style={[styles.circle, active === index + 1 ? styles.active : styles.inactive,
              { borderColor: theme === 'light' ? '#FFF' : '#191919' }
              ]}
              onMouseOver={() => this.hover(index)}
              onMouseOut={this.reset}
              onClick={() => setStep(index + 1)}
              onKeyDown={() => setStep(index + 1)} />
            {step.heading &&
              !HAS_TOUCH && (
                <span
                  style={[
                    styles.bubble,
                    horizontal ? styles.horizontalBubble : styles.verticalBubble
                  ]}>
                  <div
                    style={[
                      hover === index
                        ? { opacity: 1 }
                        : { opacity: 0, transform: 'translateX(-1em)' }
                    ]}>
                    <div style={[styles.bubbleText]}>
                      <Arrow />
                      {step.heading}
                    </div>
                  </div>
                </span>
              )}
          </li>
        ))}
      </ol>
    )
  }
}

const styles = {
  base: {
    listStyle: 'none',
    padding: 0,
    margin: '.5em 0',
    display: 'inline-flex',
    fontSize: '150%',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity .25s ease',
    zIndex: 10,
    width: '100%'
  },
  hide: {
    opacity: 0
  },
  show: {
    opacity: 1
  },
  step: {
    flex: '0 0 1.5em',
    width: '1em',
    height: '1em',
    position: 'relative',
    display: 'flex'
  },
  active: {
    width: '1em',
    height: '1em',
    background: 'transparent',
    borderWidth: '2px',
    borderStyle: 'solid',
    ':hover': {
      background: 'transparent'
    }
  },
  inactive: {
    background: '#999',
    borderWidth: '2px',
    borderColor: '#999',
    ':hover': {
      background: '#191919',
      borderColor: '#191919'
    }
  },
  circle: {
    margin: 'auto',
    boxSizing: 'border-box',
    width: '.5em',
    position: 'relative',
    transform: 'translate3d(0,0,0)',
    height: '.5em',
    borderRadius: '50%',
    borderWidth: '2px',
    transition: '.25s',
    cursor: 'pointer'
  },
  bubble: {
    position: 'absolute',
    display: 'inline-block',
    padding: '0.4em 0.4em 0.8em',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    fontSize: '57%',
    borderRadius: '0.2em',
    color: '#191919',
    letterSpacing: '.1em',
    textTransform: 'uppercase',
    fontWeight: 400,
    pointerEvents: 'none'
  },
  horizontalBubble: {
    left: '50%',
    bottom: '-2em',
    transform: 'translateX(-50%)'
  },
  verticalBubble: {
    bottom: '50%',
    left: '2em',
    transform: 'translateY(50%)'
  },
  bubbleText: {
    position: 'relative',
    top: '.2em',
    left: '10px',
    transition: '.25s',
    padding: '1em .5em .66em .5em',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ddd',
    background: 'white',
    borderRadius: '0.2em'
  }
}

export default Radium(StepCounter)



// WEBPACK FOOTER //
// ./src/components/step-counter/index.jsx